<template>
    <el-row>
        <table-template :queryParams="queryParams" actionUrl="/searchcar/findMySearchcarList.action"
                        ref="searchcarTable">
            <template slot="search">
                <el-select @change="onStatusChange" clearable placeholder="状态" style="margin-left:5px;"
                           v-model="queryParams.status">
                    <el-option :value="1" label="求购中"></el-option>
                    <el-option :value="2" label="已取消"></el-option>
                </el-select>
                <el-date-picker
                        style="margin-left:10px;"
                        v-model="queryParams.startEndTime"
                        @change="onDateTimeChange"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                </el-date-picker>
                <el-input v-model="queryParams.keyWord" style="margin-left:10px;width:230px;" placeholder="手机号/求购地址/车辆信息"></el-input>
                <el-button style="margin-left:10px;" type="primary" @click="$refs['searchcarTable'].search()">搜索</el-button>
                <el-button @click="excelExport()" v-permissions="'exportSearchCar'" >导出</el-button>
            </template>
            <template slot="item">
                <el-table-column
                    label="求购用户"
                    prop="emName">
                <template scope="scope">
                    {{scope.row.emName}}<br>
                    {{scope.row.emPhone}}<br>
                    {{scope.row.businessName}}
                </template>
            </el-table-column>

                <el-table-column
                        label="邀请关系"
                        prop="emName">
                    <template scope="scope">
                        {{scope.row.inviterIntranetName}}<br>
                        {{scope.row.inviterIntranetPhone}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="品牌车型"
                        prop="emName">
                    <template scope="scope">
                        {{scope.row.brand}}<br>
                        {{scope.row.series}}<br>
                        {{scope.row.category}}
                    </template>
                </el-table-column>

                <el-table-column
                        label="车源地要求"
                        prop="status" >
                    <template scope="scope">
                <span  v-if="scope.row.searchAddress">
                         {{scope.row.searchAddress}}
                  </span>
                        <span  v-if="!scope.row.searchAddress">
                         全国
                  </span>

                    </template>
                </el-table-column>

                <el-table-column
                        label="联系电话"
                        prop="phone">
                </el-table-column>

                <el-table-column
                        label="求购状态"
                        prop="status">
                    <template scope="scope">
                <span style="color:#fcb205" v-if="scope.row.status == 1">
                         求购中
                  </span>
                        <span  v-if="scope.row.status == 2 ">
                        已取消
                  </span>
                    </template>
                </el-table-column>



                <el-table-column
                        label="创建时间"
                        prop="createTime">
                    <template scope="scope">
                        <p>创建时间：{{scope.row.createTime | dateTimeFormat}}</p>
                        <p>浏览量： {{scope.row.browseCount }} </p>
                        <p>拨打量：{{scope.row.businessBrowseCount}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                        label="操作">
                    <template scope="scope">
                        <el-button type="text" @click="$router.push('saveSearchcar/'+scope.row.id)">修改</el-button>
                        <el-button :confirm-data="{id:scope.row.id,status:scope.row.status==1?2:1}" :style="{color:scope.row.status==1?'#f56c6c':'#67c23a'}" @onConfirm="$refs['searchcarTable'].search()"
                                   :confirm-text="scope.row.status==1?'取消求购':'继续求购'" requestUrl="searchcar/changeStatus.action"
                                   type="text"
                                   v-confirm>{{scope.row.status==1?'取消求购':'继续求购'}}
                        </el-button>
                    </template>
                </el-table-column>
            </template>
        </table-template>
    </el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'
import Config from '@/framework/configs/Config'

export default {
  components: {
    TableTemplate
  },
  extends: BasicPager,
  name: 'searchcarList',
  data: function () {
    return {

      queryParams: {
        startTime: null,
        endTime: null
      }
    }
  },
  methods: {
    onDateTimeChange (dates) {
      if (dates && dates.length === 2) {
        this.queryParams.startTime = dates[0].getTime()
        this.queryParams.endTime = dates[1].getTime()
      } else {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
      }
      this.$refs.searchcarTable.search()
    },
    onStatusChange: function (value) {
      this.queryParams.status = value
      this.$refs['searchcarTable'].search()
    },
    excelExport: function () {
      let userInfo = this.getLoginInfo()
      let loginPath = userInfo.loginPath
      let id = null
      if (userInfo.id) {
        id = userInfo.id
      } else if (userInfo.employeeId) {
        id = userInfo.employeeId
      }

      let url = Config.baseUrl + '/searchcar/exportSearchcar.action?token=' + userInfo.token + '&loginAccountId=' + id + '&loginPath=' + loginPath

      if (this.queryParams.status) {
        url += '&status=' + this.queryParams.status
      }

      if (this.queryParams.keyWord) {
        url += '&keyWord=' + this.queryParams.keyWord
      }

      let startTime = this.queryParams.startTime
      let endTime = this.queryParams.endTime
      if (startTime && endTime) {
        url += '&startTime=' + startTime + '&endTime=' + endTime
      }

      window.open(url)
    }
  },
  filters: {

  }
}
</script>

<style scoped>

</style>
